export enum VehicleStatusType {
  DRAFT,
  ACTIVE,
  INACTIVE,
  SOLD
}

export enum VehicleStatusLabelType {
  DRAFT = 'Draft',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  SOLD = 'Sold'
}
